module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"disabled":"Time Machine","enabled":"Time Machine Enabled!","disable":"Disable Time Machine","today":"Today is: "},"nl":{"disabled":"Tijdmachine","enabled":"Tijdmachine ingeschakeld!","disable":"Tijdmachine uitschakelen","today":"Vandaag: "}}')
  delete Component.options._Ctor
}
